import { render, staticRenderFns } from "./PostReport.vue?vue&type=template&id=db052f94"
import script from "./PostReport.vue?vue&type=script&lang=js"
export * from "./PostReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports